export const HEADER_TEST_IDS = {
  company: 'header-company',
  title: 'header-title',
};
